// @flow

import styles from './DefaultLmis.less';

import React, { Component } from 'react';

import NavLink from 'src/components/NavLink/NavLink';
import {
  Text,
  TextLink,
  Hidden,
  BulletList,
  Bullet
} from 'seek-style-guide/react';

import { locationFromHref } from '@seek/seek-jobs-seo/build/location';

type Props = {
  locale: Locale
};

const LMIS_CAMPAIGN_CODE = 'lrn:skj:sklm:jbs:btm:banner';

const HDR_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:hdr` };
const LNK_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:lnk` };
const BTN_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:btn` };
const LG_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:lg` };

const LOCALISED_LINKS = {
  AU: {
    home: '/learning/',
    tafeCourses: '/learning/search/tafe-courses',
    onlineCourses: '/learning/search/courses/study-online',
    coursesByOccupation: '/learning/careers'
  },
  NZ: {
    home: 'https://www.seeklearning.co.nz/',
    tafeCourses: 'https://www.seeklearning.co.nz/study-types/tafe',
    onlineCourses: 'https://www.seeklearning.co.nz/study-types/online',
    coursesByOccupation:
      'https://www.seeklearning.co.nz/explore-career-insights'
  }
};

export default class DefaultLmis extends Component<Props> {
  shouldComponentUpdate(nextProps: any) {
    return this.props.locale !== nextProps.locale;
  }

  render() {
    const links = LOCALISED_LINKS[this.props.locale === 'NZ' ? 'NZ' : 'AU'];

    const courseListItems = [
      {
        title: 'TAFE',
        href: links.tafeCourses
      },
      {
        title: 'Online',
        href: links.onlineCourses
      },
      {
        title: 'Courses by industry',
        href: links.coursesByOccupation
      }
    ];

    return (
      <div className={styles.root} data-automation="default-lmis">
        <h1>
          <NavLink
            component={TextLink}
            className={styles.title}
            target="_blank"
            rel="noopener noreferrer"
            location={{ ...locationFromHref(links.home), query: HDR_QUERY }}
          >
            <Text regular heading>
              Courses that get you job-ready
            </Text>
          </NavLink>
        </h1>
        <BulletList>
          <Bullet small className={styles.noIndent}>
            Industry recognised providers
          </Bullet>
          <Bullet small className={styles.noIndent}>
            Experts in career related education
          </Bullet>
        </BulletList>
        <Hidden mobile>
          <ul className={styles.courseList}>
            {courseListItems.map(courseListItem => (
              <li key={courseListItem.title} className={styles.courseListItem}>
                <NavLink
                  children={courseListItem.title}
                  className={styles.courseListLink}
                  component={TextLink}
                  location={{
                    ...locationFromHref(courseListItem.href),
                    query: LNK_QUERY
                  }}
                  rel="noopener noreferrer"
                  target="_blank"
                />
              </li>
            ))}
          </ul>
        </Hidden>
        <NavLink
          className={styles.button}
          target="_blank"
          rel="noopener noreferrer"
          location={{ ...locationFromHref(links.home), query: BTN_QUERY }}
        >
          Explore courses
        </NavLink>
        <NavLink
          className={styles.logo}
          target="_blank"
          rel="noopener noreferrer"
          location={{ ...locationFromHref(links.home), query: LG_QUERY }}
        />
      </div>
    );
  }
}
